export default __webpack_public_path__ + "static/media/d5da06ff83390b8c5d1c5b0ee44446a81580322862885.e1d0abd4.webp";